export const GET_SADDLES_QUERY = /* GraphQL */ `
  query SaddlesQuery(
    $horseId: ID
    $fromFitScore: Float
    $toFitScore: Float
    $limit: Int
    $fromPrice: Float
    $toPrice: Float
    $nextToken: String
    $sortBy: SortBy
    $filter: SaddleFitFilter2
    $sort: SaddleFitSort
  ) {
    listSaddles(
      horseId: $horseId
      fromFitScore: $fromFitScore
      toFitScore: $toFitScore
      fromPrice: $fromPrice
      toPrice: $toPrice
      limit: $limit
      nextToken: $nextToken
      sortBy: $sortBy
      filter: $filter
      sort: $sort
    ) {
      count
      nextToken
      items {
        brandName
        createdAt
        discipline
        newOrUsed
        pk
        price
        photo
        productTitle
        gallery
        quantity
        score
        size
        sk
        status
        updatedAt
        userId
        type
        color
        availableColors
        manufacturerMeasurements {
          barAngle
          gulletHeight
          gulletWidth
        }
        measurements {
          barAngle
          gulletHeight
          gulletWidth
        }
      }
    }
  }
`;
